import axios from "../../../axios";
import React, { useState } from "react";
import "./editDelete.css";
import { useSelector } from "react-redux";

const EditComment = ({ setComments, commentData, setClickEditComment, setEdited, post_id, setIsCommented }) => {
  const [updateComment, setUpdateComment] = useState(commentData?.comment);

  const user_id = useSelector((state) => state.user.currentUser.id);

  const handleClick = async () => {
    try {
      const res = await axios.put(
        `/community/post/${post_id}/comment/update/${commentData?.id}`,
        {
          user_id,
          comment: updateComment,
        }
      );
      res &&
        setIsCommented((prev) => !prev)
      setEdited(true);
      setComments([]);
      setClickEditComment(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div style={{ width: '147%' }} className="my-2 gap-3 d-flex align-items-center">
        <textarea
          type="text"
          style={{ marginLeft: "0px", resize: "none", boxShadow: "none" }}
          value={updateComment}
          onChange={(e) => setUpdateComment(e.target.value)}
          className="edit_interface"
        />
        <div className="yes_no gap-4 d-flex">
          <div className="done_discard d-flex align-items-center justify-content-center" onClick={handleClick}>
            <img style={{ marginTop: '16px' }} className="mr-1" src="/images/done.svg" alt="" />
            <span>&nbsp; Done</span>
          </div>

          <div
            className="done_discard d-flex align-items-center justify-content-center"
            onClick={(e) => setClickEditComment(false)}
          >
            <img style={{ marginTop: '16px' }} className="mr-1" src="/images/discard.svg" alt="" />
            <span>&nbsp; Discard</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditComment;
